import React from 'react';
import Select from 'react-select';

class TextField extends React.Component {

  _renderInput = (type) => {
    switch (type) {
      case 'textarea':
        return <textarea
          className="form-control"
          placeholder={this.props.fieldName}
          defaultValue={this.props.fieldContent}
          onChange={(e) => this.props.onChange(e.target.value)}
        />
      case 'select':
        return <Select
          placeholder={this.props.fieldName}
          defaultValue={this.props.fieldContent}
          {...this.props}
        />
      default:
        return <input
          className="form-control"
          placeholder={this.props.fieldName}
          defaultValue={this.props.fieldContent}
          onChange={(e) => this.props.onChange(e.target.value)}
        />
    }
  }

    render() {
      return (
          <div style={{display: 'flex',flexDirection:'row', paddingBottom:5, paddingTop:7, paddingLeft:20}}>
            <label>{this.props.fieldName} :</label>
            <div style={{paddingLeft:20, minWidth: 200}} >
              {!this.props.edit
                ? this.props.fieldContent
                : this._renderInput(this.props.type)}
            </div>
          </div>
        )
  }
}

TextField.propTypes = ({
  fieldName : React.PropTypes.string.isRequired
});

TextField.defaultProps = {
  type: 'input',
}

export default TextField;



// WEBPACK FOOTER //
// ./src/components/TextField.js